var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperPlaneSolid = function SvgPaperPlaneSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7285 1.41746L1.66058 8.3796C1.18932 8.65038 1.24921 9.3065 1.71786 9.50438L4.48554 10.6656L11.9658 4.07318C12.109 3.9456 12.3121 4.14087 12.1897 4.28928L5.91754 11.931V14.0269C5.91754 14.6414 6.65958 14.8835 7.02409 14.4383L8.6774 12.4257L11.9215 13.7848C12.2913 13.941 12.713 13.7093 12.7807 13.3109L14.6554 2.06316C14.7439 1.53723 14.1789 1.1571 13.7285 1.41746Z",
    fill: "#EC7963"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperPlaneSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper_plane_solid.81a259ca.svg";
export { ForwardRef as ReactComponent };